import httpClient from '@/api/http-client';

const endpoint = 'api/location-check-in-history';

const locationCheckInHistoryService = {
  getPage: (params) => httpClient.get(endpoint, { params }),
};

export default locationCheckInHistoryService;
